import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-service-unavailable',
  templateUrl: './service-unavailable.component.html',
  styleUrls: ['./service-unavailable.component.scss']
})
export class ServiceUnavailableComponent implements OnInit {
  @Input() message: string;

  constructor() { }

  ngOnInit() {
  }
}
